import {createActionGroup, props} from '@ngrx/store';
import {ApiResponse} from 'se-resource-types/dist/lib/common';
import {PaginationParameters} from '../../models/pagination-parameters';
import {Sale} from 'app/data/models/sale';

export const OrderHistoryActions = createActionGroup({
  source: 'Order History',
  events: {
    'Load Orders': props<{params: PaginationParameters}>(),
    'Load Orders Success': props<{ordersPage: ApiResponse<Sale[]>}>(),
    'Search Orders': props<{search: string}>(),
    'Go To Page': props<{params: PaginationParameters}>(),
    'Load Orders Failure': props<{error: any}>(),
  },
});
